import { Tag } from '@carbon/react';
import { EMPTY_CELL, LinkCell } from 'components/link-cell';

/** The row fields the DPS Area cell reads, shared by the Slot and Slot Allocation rows. */
export interface DpsAreaFields {
  dpsArea?: string | null;
  dpsAreaHref?: string | null;
  dpsAreaScheduled?: boolean | null;
}

/**
 * The DPS Area cell shared by the Slot and Slot Allocation grids: the area name linked to its
 * scenario, like every scenario-area column, plus a "Not scheduled" tag when the area is one
 * the pace captured (or the evaluation filled in for display) without scheduling the slot.
 *
 * Only an explicit `false` beside a name tags the row. `true` is a scheduled area and
 * `null` / `undefined` means no area or an evaluation baked before the marker existed.
 *
 * @param {object} props - The cell values.
 * @param {DpsAreaFields} props.row - The grid row.
 * @return {JSX.Element} The area, its link, and any not-scheduled tag.
 */
export function DpsAreaCell({ row }: { row: DpsAreaFields }) {
  return (
    <>
      <LinkCell value={row.dpsArea} href={row.dpsAreaHref} empty={EMPTY_CELL} />
      {row.dpsArea && row.dpsAreaScheduled === false && (
        <Tag size="sm" type="gray">
          Not scheduled
        </Tag>
      )}
    </>
  );
}
